import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { Carousel, Tabs } from 'antd';
import axios from 'axios';
import ArticleList from '../../components/Media/articleList';
import VideoComponent from '../../components/Media/VideoComponent';

import banner1 from '../../public/images/banner-资讯.jpg';
import banner2 from '../../public/images/banner-报告.jpg';
import banner3 from '../../public/images/banner-直播.jpg';

const { TabPane } = Tabs;
const bannerList = [
  { image: banner1, link: '', alt: '文章资讯' },
  { image: banner2, link: '', alt: '视频' },
  { image: banner3, link: '', alt: '跨境直播' },
];

export default function Media({ tab }) {
  const router = useRouter();
  const catagory = [];
  tab.forEach((item) =>
    catagory.push({ title: item.name, catalog: item.id, key: `${item.id}` })
  );
  catagory.unshift({
    title: '资讯',
    catalog: 'articles',
    key: 'articles',
  });
  const [tabList, setTabList] = useState(catagory);
  const [activeKey, setActiveKey] = useState('articles');

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Hidream讯梦国际媒体资讯，易赛诺媒体资讯"
        />
        <meta
          name="description"
          content="Hidream讯梦国际作为您提供最新跨境资讯、行业报告等内容，让您更快了解跨境行业大事件，掌握最新资讯，提升企业海外竞争力。"
        />
      </Head>

      <div className="Media">
        <div className="banner">
          <Carousel autoplay>
            {bannerList.map((banner, index) => {
              return (
                <div key={index}>
                  <Image
                    src={banner.image}
                    alt={banner.alt}
                    layout="responsive"
                  />
                </div>
              );
            })}
          </Carousel>
        </div>

        <Tabs
          activeKey={activeKey}
          type="card"
          tabPosition="top"
          animated={true}
          tabBarGutter={10}
          size="large"
          onChange={handleTabChange}
          className="mediaContent"
        >
          {tabList.map((item, index) => {
            if (item.catalog == 'articles') {
              return (
                <TabPane tab={item.title} key={item.key}>
                  <div className="bb m-auto pb-10">
                    <ArticleList />
                  </div>
                </TabPane>
              );
            } else {
              return (
                <TabPane tab={item.title} key={item.key}>
                  <div className="bb m-auto pb-10">
                    <VideoComponent catalogId={item.catalog} />
                  </div>
                </TabPane>
              );
            }
          })}
        </Tabs>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const video_catalog = await axios.get(`${process.env.BASE_URL}video_catalog`);
  const tab = await video_catalog.data.data;

  return {
    props: {
      tab,
    },
  };
}
